var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-codes"
  }, [_c('div', {
    staticClass: "d-flex align-center pt-5"
  }, [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("mdi-arrow-left")])], 1)], 1), _c('div', {
    staticClass: "page-title mono pl-3"
  }, [_vm._v(_vm._s(_vm.$t('product_qr_codes')))]), _c('v-spacer'), _c('codes-quota', {
    staticClass: "mr-8"
  })], 1), !_vm.loadingProduct ? _c('div', {
    staticClass: "product-card my-4 mx-8"
  }, [_c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "product-picture flex-grow-0 pa-0",
    style: {
      'background-image': 'url(' + _vm.getProductImage(_vm.product) + ')'
    }
  }), _c('v-col', {
    staticClass: "flex-grow-1 pa-0 pb-3 pl-3"
  }, [_c('div', {
    staticClass: "product-title font-weight-medium"
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.product.name))]), _c('button', {
    staticClass: "btn",
    attrs: {
      "title": _vm.$t('edit_product')
    },
    on: {
      "click": function ($event) {
        return _vm.editProduct();
      }
    }
  }, [_c('v-icon', {
    staticClass: "icon"
  }, [_vm._v("$edit")])], 1)]), _c('div', {
    staticClass: "product-description"
  }, [_vm._v(_vm._s(_vm.$t('product_sku')) + ": " + _vm._s(_vm.product.sku))]), _c('div', {
    staticClass: "product-description"
  }, [_vm._v(_vm._s(_vm.$t('product_description')) + ": " + _vm._s(_vm.product.description || 'N/A'))]), !_vm.isIntelligentRedirectEnabled || _vm.totalActiveCodesCount ? _c('div', {
    staticClass: "product-description"
  }, [_vm._v(" " + _vm._s(_vm.$t('product_qr_links_to')) + ": "), !_vm.isIntelligentRedirectEnabled ? [_vm.campaignRedirectionMode === 'url' ? _c('span', {
    staticClass: "redirect-setting font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('url')) + " "), _c('a', {
    attrs: {
      "href": _vm.consumerOptions.consumer_url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.consumerOptions.consumer_url))])]) : _vm._e(), _vm.campaignRedirectionMode === 'stc' ? _c('span', {
    staticClass: "redirect-setting font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('landing_page')))]) : _vm._e(), _vm.campaignRedirectionMode === 'elabel' ? _c('div', [_c('span', {
    staticClass: "redirect-setting font-weight-bold mr-2"
  }, [_vm._v(_vm._s(_vm.$t('elabel_landing_page')))]), _c('button', {
    staticClass: "btn",
    attrs: {
      "title": _vm.$t('edit_elabel_data')
    },
    on: {
      "click": function ($event) {
        return _vm.goToElabel();
      }
    }
  }, [_c('v-icon', {
    staticClass: "icon"
  }, [_vm._v("$edit")])], 1)]) : _vm._e(), _vm.campaignRedirectionMode === 'product' ? _c('span', {
    staticClass: "redirect-setting font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('product_url')) + " "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.product.client_url
    }
  }, [_vm._v(_vm._s(_vm.product.client_url))])]) : _vm._e()] : _vm.totalActiveCodesCount ? _c('span', {
    staticClass: "redirect-setting font-weight-bold"
  }, [_c('span', {
    staticClass: "link",
    on: {
      "click": _vm.goToScanSimulator
    }
  }, [_vm._v(_vm._s(_vm.$t('product_qr_simulate_scan')))])]) : _vm._e()], 2) : _vm._e(), _c('div', {
    staticClass: "product-description"
  }, [_vm._v(_vm._s(_vm.$t('product_update_redirection_settings')) + ", "), _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.goToRedirectionSettings
    }
  }, [_vm._v(_vm._s(_vm.$t('click_here')))]), _vm._v(".")])]), _c('div', {
    staticClass: "d-flex align-center ml-auto pr-9"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "black"
    }
  }, [_vm._v("mdi-qrcode")]), _vm.codesLoaded ? _c('div', {
    staticClass: "code-count font-weight-light"
  }, [_vm._v("x " + _vm._s(_vm.filteredCodeCount))]) : _vm._e(), _c('v-btn', {
    staticClass: "ml-6",
    attrs: {
      "loading": _vm.isCreatingCode,
      "raised": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleDisplayQrCodeDialog(true);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t('product_new_qr_code')))], 1)], 1)], 1)], 1) : _vm._e(), _vm.loadingProduct ? _c('div', {
    staticClass: "skeleton-ctn my-4 mx-8"
  }, [_c('v-skeleton-loader', {
    attrs: {
      "width": "100%",
      "type": "avatar, paragraph"
    }
  })], 1) : _vm._e(), _vm.sortedCodes.length && _vm.codesLoaded ? _c('div', {
    staticClass: "d-flex align-center justify-space-between selection-settings mx-8"
  }, [_c('div', {
    staticClass: "d-flex align-center flex-wrap py-1"
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "value": _vm.selectAllEnabled
    },
    on: {
      "click": function ($event) {
        return _vm.toggleSelectAll();
      }
    }
  }), _c('div', {
    staticClass: "search-label mr-4"
  }, [_vm._v(_vm._s(_vm.$t('selected')) + ": " + _vm._s(_vm.selectAllEnabled ? _vm.filteredCodeCount : _vm.selectedCodesIndexes.length))]), _vm.codesLoaded === true ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "search-label mr-2"
  }, [_vm._v(_vm._s(_vm.$t('bulk_actions')) + ":")]), _c('code-tag-editor', {
    attrs: {
      "isDisabled": !_vm.selectedCodes.length,
      "count": _vm.filteredCodeCount,
      "tags": _vm.scmFields,
      "edit-mode": "bulk",
      "select-all": _vm.selectAllEnabled,
      "product": _vm.product.id,
      "codes": _vm.selectedCodes,
      "campaign": _vm.selectedCampaign.id
    },
    on: {
      "update-done": _vm.onUpdateDone
    }
  }), _c('code-change-product', {
    attrs: {
      "isDisabled": !_vm.selectedCodes.length || _vm.isGs1CodeSelected,
      "mode": "bulk",
      "count": _vm.filteredCodeCount,
      "select-all": _vm.selectAllEnabled,
      "product": _vm.product.id,
      "campaign": _vm.selectedCampaign.id,
      "codes": _vm.selectedCodes
    },
    on: {
      "code-transfered": _vm.onCodeTransfered
    }
  }), _c('download', {
    attrs: {
      "isDisabled": !_vm.selectedCodes.length,
      "mode": "product",
      "codes": _vm.selectedCodes,
      "product": _vm.product.id,
      "select-all": _vm.selectAllEnabled,
      "count": _vm.filteredCodeCount,
      "elabel-data": _vm.elabelData,
      "enable-qr-text-settings": true
    }
  })], 1) : _vm._e()], 1), _c('button', {
    staticClass: "d-flex show-url-btn",
    on: {
      "click": function ($event) {
        _vm.showUrl = !_vm.showUrl;
      }
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.visibilityImgUrl
    }
  }), _vm.showUrl ? _c('span', [_vm._v(_vm._s(_vm.$t('hide_url_prefixes')))]) : _vm._e(), !_vm.showUrl ? _c('span', [_vm._v(_vm._s(_vm.$t('show_url_prefixes')))]) : _vm._e()], 1)]) : _vm._e(), _c('div', {
    staticClass: "code-list-ctn mx-8",
    class: {
      'no-border': !_vm.sortedCodes.length && _vm.codesLoaded
    }
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.codesLoaded,
      expression: "!codesLoaded"
    }],
    attrs: {
      "indeterminate": ""
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.codesLoaded,
      expression: "codesLoaded"
    }]
  }, _vm._l(_vm.sortedCodes, function (code, codeIndex) {
    return _c('div', {
      key: code.id,
      staticClass: "code-line py-1 d-flex align-center",
      class: {
        'flash': code.isNew
      }
    }, [_c('div', {
      staticClass: "d-flex flex-wrap align-center"
    }, [_c('div', {
      staticClass: "d-flex flex-no-wrap"
    }, [_c('v-checkbox', {
      attrs: {
        "hide-details": "",
        "color": "#15bbf0",
        "value": _vm.selectedCodesIndexes.indexOf(codeIndex) >= 0
      },
      on: {
        "click": function ($event) {
          return _vm.toggleSelectCode(codeIndex);
        }
      }
    }), _c('div', {
      staticClass: "mono word-break-all"
    }, [_vm._v(_vm._s(_vm.showUrl ? code.scm_data.scantrust_url_prefix ? code.scm_data.scantrust_url_prefix : _vm.singleNonSystemPrefix ? _vm.singleNonSystemPrefix : _vm.systemPrefix : '') + _vm._s(code.message) + _vm._s(code.scm_data.gs1_data_attributes ? `?${code.scm_data.gs1_data_attributes}` : ''))])], 1), _vm._l(_vm.filterScmData(code.scm_data), function (value, name) {
      return _c('v-chip', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: value,
          expression: "value"
        }],
        key: `code-${code.id}-tags-${name}-${value}`,
        staticClass: "ml-2",
        attrs: {
          "color": "#f1f1f1",
          "text-color": "#0789b2"
        }
      }, [_vm._v(_vm._s(value) + " ")]);
    }), _vm._l(_vm.getGS1ScmData(code), function (gs1Field) {
      return _c('v-chip', {
        key: `gs1_tag_${gs1Field.key}`,
        staticClass: "ml-2",
        attrs: {
          "color": "#f1f1f1",
          "text-color": "#0789b2"
        }
      }, [_c('span', {
        staticClass: "product-tag-text"
      }, [_vm._v(_vm._s(`${gs1Field.key.toUpperCase()}: ${gs1Field.value}`))])]);
    })], 2), _c('v-spacer'), _c('div', {
      staticClass: "d-flex flex-shrink-0 align-center"
    }, [_c('div', {
      staticClass: "date mono mr-2"
    }, [_vm._v(_vm._s(code.activated_at ? _vm.formatDate(code.activated_at) : _vm.formatDate(code.creation_date)))]), _c('div', {
      staticClass: "icons-wrapper d-flex justify-end"
    }, [_c('code-tag-editor', {
      attrs: {
        "tags": _vm.scmFields,
        "codes": [code],
        "campaign": _vm.selectedCampaign.id
      }
    }), _c('download', {
      attrs: {
        "mode": "single",
        "codes": [code],
        "elabel-data": _vm.elabelData,
        "enable-qr-text-settings": true
      }
    }), _c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "primary",
              "icon": ""
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)];
        }
      }], null, true)
    }, [_c('v-list', [_vm.isCodeSpacesEnabled && !_vm.isGS1Code(code.message) ? _c('v-list-item', {
      on: {
        "click": function ($event) {
          return _vm.handleDisplayUniqueIdEdit(code);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('qrcode_edit_unique_identifier')))])], 1) : _vm._e(), _vm.isCodeSpacesEnabled ? _c('v-list-item', {
      on: {
        "click": function ($event) {
          return _vm.handleDisplayGS1Edit(code);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.isGS1Code(code.message) ? _vm.$t('qrcode_edit_gs1_link') : _vm.$t('qrcode_convert_to_gs1_link')))])], 1) : _vm._e(), !_vm.isGS1Code(code.message) ? _c('v-list-item', {
      on: {
        "click": function ($event) {
          return _vm.handleDisplayTransferModal(code);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('transfer_code')))])], 1) : _vm._e()], 1)], 1)], 1)])], 1);
  }), 0), !_vm.sortedCodes.length && _vm.codesLoaded ? _c('div', {
    staticClass: "code-empty-state py-2"
  }, [_c('div', [_c('img', {
    staticClass: "guide-arrow rotate-180",
    attrs: {
      "src": require("@/assets/guide_arrow.svg")
    }
  }), _vm._v(" " + _vm._s(_vm.$t('product_no_codes_empty_state_1')) + " "), _c('span', {
    staticClass: "link font-weight-bold",
    on: {
      "click": function ($event) {
        return _vm.handleDisplayQrCodeDialog(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('product_no_codes_empty_state_2')))]), _vm._v(" " + _vm._s(_vm.$t('product_no_codes_empty_state_3')) + " ")])]) : _vm._e(), _c('div', {
    staticClass: "pagination-ctn mt-5 mb-4"
  }, [_c('v-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.codesLoaded && _vm.filteredCodeCount,
      expression: "codesLoaded && filteredCodeCount"
    }],
    attrs: {
      "color": "primary",
      "total-visible": 7,
      "length": _vm.nbPages
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1), _c('v-dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.productDialog,
      expression: "productDialog"
    }],
    attrs: {
      "width": "900",
      "persistent": true
    },
    model: {
      value: _vm.productDialog,
      callback: function ($$v) {
        _vm.productDialog = $$v;
      },
      expression: "productDialog"
    }
  }, [_c('product-form', {
    key: _vm.productDialog,
    attrs: {
      "campaign": _vm.selectedCampaign.id,
      "product": _vm.product,
      "product-id": _vm.product.id
    },
    on: {
      "on-close-dialog": _vm.handleCloseProductDialog
    }
  })], 1), _vm.displayDialog ? _c('generate-qr-code-dialog', {
    attrs: {
      "display-dialog": _vm.displayDialog,
      "selected-product": _vm.product,
      "is-converting-to-gs1": _vm.isConvertingToGs1
    },
    on: {
      "update:displayDialog": function ($event) {
        _vm.displayDialog = $event;
      },
      "update:display-dialog": function ($event) {
        _vm.displayDialog = $event;
      }
    }
  }) : _vm._e(), _c('edit-confirmation-modal', {
    attrs: {
      "display-edit-modal": _vm.displayEditModal,
      "selected-code": _vm.code
    },
    on: {
      "update:displayEditModal": function ($event) {
        _vm.displayEditModal = $event;
      },
      "update:display-edit-modal": function ($event) {
        _vm.displayEditModal = $event;
      },
      "open-dialog": _vm.handleDisplayQrCodeDialog
    }
  }), _vm.code ? _c('code-change-product', {
    ref: "transfer-code",
    attrs: {
      "codes": [_vm.code],
      "hide-open-dialog-button": true
    },
    on: {
      "code-transfered": _vm.onCodeTransfered
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }